import * as Scrivito from "scrivito";
import LinkList from "./LinkList";

function FirstLevel({ elems, currentPage }) {
  return (
    <div>
      <div className="bg-white border-top">
        <LinkList
          elems={elems}
          classNameLink="bg-white"
          className="border-bottom"
          iconSide={"right"}
          currentPage={currentPage}
          level={1}
        />
      </div>
    </div>
  );
}

export default Scrivito.connect(FirstLevel);
